export const ADJUSTMENT_TYPES = {
  AS_COMPLETE: 'As Complete',
  AS_STABILIZED: 'As Stabilized',
  NPV: 'Net Present Value',
};

export const ADJUSTMENT_TYPES_MAP = {
  [ADJUSTMENT_TYPES.AS_COMPLETE]: 'asCompleteNpvAdjustments',
  [ADJUSTMENT_TYPES.AS_STABILIZED]: 'asStabilizedNpvAdjustments',
  [ADJUSTMENT_TYPES.NPV]: 'npvAdjustments',
};

export const Labels = {
  ADD_ADJUSTMENT: '+ New Adjustment',
  ADD_COMMERCIAL_RENT_LOSS: '+ New Commercial Rent Loss',
  ADD_DEDUCTION: '+ New Deduction',
  ADD_RESIDENTIAL_RENT_LOSS: '+ New Residential Rent Loss',
};

export const RENT_LOSS_LABELS = {
  RESIDENTIAL: 'Residential Rent Loss',
  COMMERCIAL: 'Commercial Rent Loss',
};

export const ROUNDING_OPTIONS = [5000, 10000, 25000, 50000, 100000, 500000, 1000000, 5000000, 10000000, 50000000];

export const LOSS_ITEM_KEYS = {
  COMMERCIAL_UNDETERMINED_RENT_LOSS: 'Undetermined Commercial Rent Loss',
  COMMISSION_FEE: 'Commission Fee',
  BUYOUT_COST: 'Buyout Cost',
  ENTREPRENEURIAL_PROFIT: 'Entrepreneurial Profit*',
};
